<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-1']">{{presentacion.titulo}}</h3>
                <div :class="['row']">
                    <div :class="['col-lg-12', 'col-md-12', '']"  >
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <hr :class="['mt-1', 'mb-3']">
    			   
                                <div>
                                    <p v-html="presentacion.contenido"></p>
                                </div>	 
               
                                <div :class="['table-responsive']">
                                    <table :class="['table', 'table-condensed', 'table-bordered']" >
                                        <thead>
                                            <tr :class="['fuente13', 'bg_color_drasam']" >
                                                <th>#</th>
                                                <th>AGENCIA</th>
                                                <th>REPRESENTANTE</th>
                                                <th>TELEFONO FIJO</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr :class="['fuente13']" v-for="(val, key) in agencias" :key="key" >
                                                <td>{{key+1}}</td>
                                                <td>
                                                    <span :class="['text_color_drasam', 'fuenteBold']">{{val.agencia}}</span>
                                                    <div :class="['d-flex', 'flex-row', 'mb-0']"> 
                                                        <i :class="['fa', 'fa-map-marker', 'fa-2x', 'mr-2', 'text_color_drasam']" aria-hidden='true'></i>
                                                        Direccion: {{val.direccion_agencia}}
                                                    </div>
                                                </td>

                                                <td>                    	
                                                    <div :class="['second', 'd-flex', 'flex-row', 'mt-0']">
                                                        <div :class="['image', 'mr-1']">
                                                            <img :src="(val.responsable && val.responsable.foto)?val.responsable.path_file_foto:'img/profile.png'" :class="['rounded-circle']" width="60" height="60" />
                                                        </div>
                                                        <div class="">
                                                            <div :class="['', 'flex-row', 'mb-0']"> 
                                                                <span>
                                                                    {{(val.responsable && val.responsable.nombres)?val.responsable.nombres:'Sin responsable'}} 
                                                                    {{(val.responsable && val.responsable.apellido_paterno)?val.responsable.apellido_paterno:''}} 
                                                                    {{(val.responsable && val.responsable.apellido_materno)?val.responsable.apellido_materno:''}}
                                                                </span>
                                                                <br>
                                                                <span>
                                                                    <i :class="['fa', 'fa-envelope', 'fa-1x', 'mr-2', 'text_color_drasam']" aria-hidden='true'></i>
                                                                    {{(val.responsable && val.responsable.email)?val.responsable.email:'-'}}
                                                                </span>
                                                                <br>
                                                                <span>
                                                                     <i :class="['fa', 'fa-phone', 'fa-1x', 'mr-2', 'text_color_drasam']" aria-hidden='true'></i>
                                                                    {{(val.responsable && val.responsable.telefono)?val.responsable.telefono:'-'}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <i :class="['fa', 'fa-volume-control-phone', 'mr-2', 'fa-2x']" aria-hidden="true"></i>
                                                    {{val.telefono_agencia?val.telefono_agencia:'Sin telefono'}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'Agencias',
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Agencias || "+((this.empresa.abreviatura)?this.empresa.abreviatura:"DRASAM");
            this.getAgencia();
        },
        data(){
            return{
                presentacion:{
                    titulo:"",
                    contenido:"",
                },
                agencias:[],
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            getAgencia(){
                this.setLoading(true);
                this.$http.get('webserviceserver/ade').then((res)=>{
                    if(res.data.Presentation)
                        this.presentacion = res.data.Presentation;
                    if(res.data.Dependency)
                        this.agencias     = res.data.Dependency;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>